import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './styles.scss';

class MediaPlayer extends Component {
  static propTypes = {
    type: PropTypes.string,
    url: PropTypes.string,
    index: PropTypes.number,
    duration: PropTypes.number,
    onPlaybackDone: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (this.props.type && this.props.type !== 'VIDEO') {
      setTimeout(this.props.onPlaybackDone, this.props.duration || 8000);
    }
    if (this.props.type && this.props.type === 'VIDEO' && this.props.duration > 0) {
      setTimeout(this.props.onPlaybackDone, this.props.duration || 10000);
    }

  }


  componentDidUpdate(prevProps) {
    if (this.mediaDisplayRef && !this.state.height) {
      this.setState({
        height: this.mediaDisplayRef.parentElement.parentElement.clientHeight
      });

    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.index !== nextProps.index && nextProps.type !== 'VIDEO') {
      setTimeout(this.props.onPlaybackDone, nextProps.duration || 5000);

    }
    if (this.props.index !== nextProps.index && nextProps.type === 'VIDEO' && nextProps.duration > 0) {
      setTimeout(this.props.onPlaybackDone, nextProps.duration || 10000);

    }

  }



  mediaElement() {
    switch (this.props.type) {
      case 'IMAGE':
        return <img src={this.props.url} />;
      case 'VIDEO':
        return <video src={this.props.url} autoPlay onEnded={this.props.onPlaybackDone} />;
      case 'PDF':
        return <embed src={this.props.url} type="application/pdf" width="100%" />;
      case 'WEB':
      case 'FEED':
        return <iframe src={this.props.url} />;
      case 'URL':
        return <span style={{ color: 'white' }}>{'URL Asset: '}<a href={this.props.url}>{this.props.url}</a></span>;
      default:
        return null;
    }
  }

  render() {
    const style = {};
    if (this.state.height) {
      style['height'] = this.state.height;
    }
    return (
      <div className="media-display" style={style} ref={el => this.mediaDisplayRef = el}>
        {this.mediaElement()}
      </div>
    );
  }
}

export default MediaPlayer;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/MediaPlayer/index.js